import React from 'react';
import { CollaborationSection, SubpageBanner, ProgramFeatures, WhyJoinUs, Cta1 } from '../components';
import { useTranslation, Trans } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

const ReferralProgram = () => {
    const { t } = useTranslation();
    const { isAuthenticated } = useAuth();

    return (
        <div>
            <SubpageBanner
                title={t('referral.bannerTitle')}
                page={t('referral.bannerPage')}
                textTitle={t('referral.bannerTextTitle')}
                text={t('referral.bannerText')}
                button={isAuthenticated ? t('referral.bannerButton2') : t('referral.bannerButton')}
                buttonLink={isAuthenticated ? '/referral-code' : '/account'}
                path="/referral-program"
            />
            <div className="referans-programi">
                <div className="container">
                    <ProgramFeatures />
                </div>
                {/* <CollaborationSection /> */}
                <div className="container">
                    <WhyJoinUs />
                </div>
                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default ReferralProgram;
